import React, { useState, useEffect } from 'react'
import Aside from './components/0.core/Aside';
import Content from './components/0.core/Content';
import Dashboard from './components/admin/Dashboard';
import { AuthProvider } from './contexts/AuthContext';
import './assets/css/App.css';
import './i18n'; // Initialisation d'i18n

const App = () => {
  const [currentView, setCurrentView] = useState('portfolio');

  useEffect(() => {
    // Vérifier l'URL pour déterminer la vue à afficher
    const checkUrl = () => {
      const hash = window.location.hash;
      const pathname = window.location.pathname;
      
      if (pathname.includes('/admin') || hash === '#admin') {
        setCurrentView('admin');
      } else {
        setCurrentView('portfolio');
      }
    };

    // Vérifier au chargement
    checkUrl();

    // Écouter les changements d'URL
    window.addEventListener('hashchange', checkUrl);
    window.addEventListener('popstate', checkUrl);

    return () => {
      window.removeEventListener('hashchange', checkUrl);
      window.removeEventListener('popstate', checkUrl);
    };
  }, []);

  return (
    <AuthProvider>
      {currentView === 'admin' ? (
        <Dashboard />
      ) : (
        <>
          <div id='top'></div>
          <div id='main'>
            <Aside />
            <Content />
          </div>
        </>
      )}
    </AuthProvider>
  )
} 

export default App
 